import { render, staticRenderFns } from "./errorStop.vue?vue&type=template&id=71511b84&scoped=true"
import script from "./errorStop.vue?vue&type=script&lang=js"
export * from "./errorStop.vue?vue&type=script&lang=js"
import style0 from "./errorStop.vue?vue&type=style&index=0&id=71511b84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../Users/zhc/Documents/CF40/CF40-Java/cf40_pc_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71511b84",
  null
  
)

export default component.exports